import React from 'react';
import { createComponent } from '@lit/react';
import { IxSearchBar as LitComp } from '../IxSearchBar.js';

customElements.define('ix-search-bar', LitComp);

export const IxSearchBar = createComponent({
  tagName: 'ix-search-bar',
  elementClass: LitComp,
  react: React,
});
